import * as React from "react";
import { TextField } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const MenuItemNotes: React.FC<Props> = ({ value, onChange }) => {
  return (
    <div className="row" style={{marginTop: 15}}>
      <div className="col-12">
        <TextField
          variant="outlined"
          name="notes"
          minRows={4}
          value = {value}
          fullWidth={true}
          multiline={true}
          label={LocalizerHelper.localized('notes')}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default MenuItemNotes;
